import { ReactNode, useState } from "react";
import { DndSortChangeEvent } from "../types";
import { DEFAULT_CONTEXT_VALUE, DndSortContext } from "./DndSortContext";

/**
 * Our internal context provider for the DndSort system. Not to be confused with DndContext which is the `dnd-kit` context.
 * @param props
 * @param props.children The children components that will have access to the context
 */
export default function DndSortContextProvider({
  children,
  onDrop,
}: {
  children: ReactNode;
  onDrop: (event: DndSortChangeEvent) => void;
}) {
  const [previewRenderer, setPreviewRenderer] = useState(
    () => DEFAULT_CONTEXT_VALUE.previewRenderer,
  );

  return (
    <DndSortContext.Provider
      value={{
        previewRenderer,
        setPreviewRenderer,
        onDrop,
      }}
    >
      {children}
    </DndSortContext.Provider>
  );
}
